





















import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Tools extends Vue {
  get isToolsList () {
    return this.$route.name === 'tools'
  }
}
